
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Versionsvergleich() {
  const features = [
    { name: 'Kundenverwaltung', eco: true, premium: true },
    { name: 'Auftragsverwaltung', eco: true, premium: true },
    { name: 'Artikelverwaltung', eco: true, premium: true },
    { name: 'LV-System', eco: true, premium: true },
    { name: 'Zahlungsüberwachung', eco: true, premium: true },
    { name: 'Brieftext/Rundschreiben', eco: true, premium: true },
    { name: 'Datensicherung', eco: true, premium: true },
    { name: 'Handbuch/Hilfe', eco: true, premium: true },
    { name: 'Basis-Aufmaß', eco: false, premium: true },
    { name: 'Aufmaß-Erweiterung', eco: false, premium: true },
    { name: 'Vorkalkulation', eco: false, premium: true },
    { name: 'Nachkalkulation', eco: false, premium: true },
    { name: 'E-Mail Versand', eco: false, premium: true },
    { name: 'XRechnung', eco: false, premium: true },
    { name: 'Bauzeit Pro', eco: false, premium: true },
    { name: 'Preisspiegel', eco: false, premium: true },
    { name: 'Tagesberichte', eco: false, premium: true },
    { name: 'Lagerverwaltung', eco: false, premium: true },
    { name: 'Jahresverträge', eco: false, premium: true },
    { name: 'Lieferscheinaufstellung', eco: false, premium: true },
    { name: 'Mandanten-Installation', eco: false, premium: true },
    { name: 'Adressetiketten-Druck', eco: false, premium: true }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-lightBlue to-primary-100 py-20 lg:py-32 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/cec40517b5bc8e2bc5fe4873603676ce.jpg')`
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              <span className="text-primary-600">Versionsvergleich</span><br />
              baufaktura PREMIUM & ECO
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed max-w-3xl mx-auto">
              Wählen Sie die passende Baufaktura-Version für Ihren Handwerksbetrieb. 
              Beide Versionen bieten bewährte Grundfunktionen - PREMIUM erweitert diese um professionelle Features.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" className="text-lg px-8 py-4">
                <i className="ri-download-line mr-2"></i>
                ECO Version testen
              </Button>
              <Button variant="outline" size="lg" className="text-lg px-8 py-4">
                <i className="ri-star-line mr-2"></i>
                PREMIUM Version testen
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Version Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
            {/* ECO Version */}
            <div className="bg-gradient-to-br from-lightGrey to-lightGrey/80 rounded-3xl p-8 lg:p-12">
              <div className="w-20 h-20 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-leaf-line text-3xl text-green-600"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">baufaktura ECO</h2>
              <p className="text-lg text-gray-600 mb-6">
                Die kostengünstige Einstiegslösung mit allen wichtigen Grundfunktionen 
                für die tägliche Arbeit im Handwerksbetrieb.
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                  <span className="text-gray-700">Alle Grundfunktionen enthalten</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                  <span className="text-gray-700">Perfekt für kleinere Betriebe</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                  <span className="text-gray-700">Günstiger Einstiegspreis</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                  <span className="text-gray-700">Einfache Bedienung</span>
                </div>
              </div>
              <Button variant="outline" fullWidth size="lg">
                ECO Version wählen
              </Button>
            </div>

            {/* PREMIUM Version */}
            <div className="bg-gradient-to-br from-lightBlue to-primary-100 rounded-3xl p-8 lg:p-12 border-2 border-primary-200 relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-primary-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                  Empfohlen
                </span>
              </div>
              <div className="w-20 h-20 bg-lightBlue rounded-xl flex items-center justify-center mb-6">
                <i className="ri-star-line text-3xl text-primary-600"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">baufaktura PREMIUM</h2>
              <p className="text-lg text-gray-600 mb-6">
                Die vollständige Lösung mit allen professionellen Funktionen 
                für anspruchsvolle Handwerksbetriebe jeder Größe.
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                  <span className="text-gray-700">Alle ECO-Funktionen inklusive</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                  <span className="text-gray-700">Erweiterte Aufmaß-Funktionen</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                  <span className="text-gray-700">Vor- und Nachkalkulation</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-circle-fill text-green-500 mr-3"></i>
                  <span className="text-gray-700">Professionelle Zusatzmodule</span>
                </div>
              </div>
              <Button fullWidth size="lg">
                PREMIUM Version wählen
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Detailed Comparison Table */}
      <section className="py-20 bg-lightGrey">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Detaillierter Funktionsvergleich
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Alle Funktionen im direkten Vergleich - finden Sie die passende Version für Ihren Betrieb.
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
            {/* Table Header */}
            <div className="bg-gradient-to-r from-primary-600 to-primary-700 text-white">
              <div className="grid grid-cols-3 gap-4 p-6">
                <div className="text-left">
                  <h3 className="text-xl font-bold">Funktionen</h3>
                </div>
                <div className="text-center">
                  <h3 className="text-xl font-bold">ECO</h3>
                  <p className="text-primary-100 text-sm mt-1">Grundausstattung</p>
                </div>
                <div className="text-center">
                  <h3 className="text-xl font-bold">PREMIUM</h3>
                  <p className="text-primary-100 text-sm mt-1">Vollausstattung</p>
                </div>
              </div>
            </div>

            {/* Table Body */}
            <div className="divide-y divide-gray-200">
              {features.map((feature, index) => (
                <div key={index} className={`grid grid-cols-3 gap-4 p-4 ${index % 2 === 0 ? 'bg-lightGrey/30' : 'bg-white'}`}>
                  <div className="flex items-center">
                    <span className="text-gray-900 font-medium">{feature.name}</span>
                  </div>
                  <div className="flex justify-center items-center">
                    {feature.eco ? (
                      <i className="ri-check-circle-fill text-green-500 text-xl"></i>
                    ) : (
                      <i className="ri-close-circle-fill text-gray-300 text-xl"></i>
                    )}
                  </div>
                  <div className="flex justify-center items-center">
                    {feature.premium ? (
                      <i className="ri-check-circle-fill text-green-500 text-xl"></i>
                    ) : (
                      <i className="ri-close-circle-fill text-gray-300 text-xl"></i>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Table Footer */}
            <div className="bg-lightGrey p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="text-center">
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">baufaktura ECO</h4>
                  <p className="text-gray-600 mb-4">Ideal für Einsteiger und kleinere Betriebe</p>
                  <Button variant="outline" size="lg" fullWidth>
                    <i className="ri-download-line mr-2"></i>
                    ECO kostenlos testen
                  </Button>
                </div>
                <div className="text-center">
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">baufaktura PREMIUM</h4>
                  <p className="text-gray-600 mb-4">Für professionelle Ansprüche aller Betriebsgrößen</p>
                  <Button size="lg" fullWidth>
                    <i className="ri-star-line mr-2"></i>
                    PREMIUM kostenlos testen
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Differences */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Die wichtigsten Unterschiede
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Diese Zusatzfunktionen machen baufaktura PREMIUM zur professionellen Komplettlösung.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-lightBlue rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-ruler-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Aufmaß-System</h3>
              <p className="text-gray-600">
                Basis- und erweiterte Aufmaß-Funktionen für präzise Mengenermittlung 
                und professionelle Abrechnung.
              </p>
            </div>

            <div className="bg-lightBlue rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-calculator-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Kalkulation</h3>
              <p className="text-gray-600">
                Vor- und Nachkalkulation für bessere Kostenkontrolle 
                und optimierte Preisgestaltung.
              </p>
            </div>

            <div className="bg-lightBlue rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-mail-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">E-Mail & XRechnung</h3>
              <p className="text-gray-600">
                Direkter E-Mail-Versand von Dokumenten und XRechnung 
                für moderne Geschäftsabwicklung.
              </p>
            </div>

            <div className="bg-lightBlue rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Bauzeit Pro</h3>
              <p className="text-gray-600">
                Professionelle Zeiterfassung und Projektmanagement 
                für optimierte Arbeitsabläufe.
              </p>
            </div>

            <div className="bg-lightBlue rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-box-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Lagerverwaltung</h3>
              <p className="text-gray-600">
                Vollständige Lagerverwaltung mit Bestandsführung 
                und automatischen Nachbestellungen.
              </p>
            </div>

            <div className="bg-lightBlue rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-file-chart-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Tagesberichte</h3>
              <p className="text-gray-600">
                Detaillierte Tagesberichte und Auswertungen 
                für bessere Betriebsführung.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-primary-600 to-primary-700 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            Welche Version passt zu Ihrem Betrieb?
          </h2>
          <p className="text-xl text-primary-100 mb-8 max-w-2xl mx-auto">
            Testen Sie beide Versionen kostenlos und unverbindlich. 
            Unsere Experten beraten Sie gerne bei der Auswahl.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="outline" size="lg" className="text-lg px-8 py-4 border-white text-white hover:bg-white hover:text-primary-600">
              <i className="ri-phone-line mr-2"></i>
              Kostenlose Beratung
            </Button>
            <Button size="lg" className="text-lg px-8 py-4 bg-white text-primary-600 hover:bg-gray-100">
              <i className="ri-download-line mr-2"></i>
              Beide Versionen testen
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
